import { useGrowthbook } from '@experience/core-hostapp-share-lib';

export const LISTING_LABELS_V3_EXPERIMENT = 'listing_labels_v3';

export const useListingLabelsV3Experiment = () => {
  const gb = useGrowthbook();

  const isListingLabelsV3ExperimentActive = gb?.isOn(LISTING_LABELS_V3_EXPERIMENT) ?? false;

  return {
    isListingLabelsV3ExperimentActive,
  };
};
